import * as React from 'react'
import { RichText } from 'prismic-reactjs'
import CustomLink from '../../utils/prismic-content-link'

export const Masthead = ({title, summary, services, cssClass}) => {
    return (
        <div className={`c-masthead ${cssClass ? cssClass : ''}`}>
            <div className="c-masthead__container">
                <div className="container-fluid">
                    <div className="row">
                        <div className="c-masthead__title-container">
                            <h1 className="c-masthead__title">{title}</h1>
                            {services ? <div className="c-masthead__services"><RichText render={services} serializeHyperlink={CustomLink} /></div> : null}
                        </div>
                        {summary ? <div className="c-masthead__summary-container"><div className="c-masthead__summary cms-content"><RichText render={summary} serializeHyperlink={CustomLink} /></div></div> : null}
                    </div>
                </div>
            </div>
        </div>
    )
  }

export default Masthead